var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArchitecture = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Measure-Ruler-Divider--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Measure Ruler Divider Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.79 20.7a1.69 1.69 0 0 0 0.37 -1.83L12 8.33a0.48 0.48 0 0 0 -0.44 -0.33 0.49 0.49 0 0 0 -0.46 0.18 3.5 3.5 0 0 1 -1.89 1.21 0.51 0.51 0 0 0 -0.33 0.26 0.49 0.49 0 0 0 0 0.41l4 10.07a1.74 1.74 0 0 0 0.93 1 1.9 1.9 0 0 0 0.57 0.14l0.78 2a0.75 0.75 0 0 0 0.7 0.48 0.65 0.65 0 0 0 0.27 -0.05 0.75 0.75 0 0 0 0.43 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.54 9.39A3.54 3.54 0 0 1 5.65 8.2a0.48 0.48 0 0 0 -0.46 -0.2 0.49 0.49 0 0 0 -0.39 0.31L0.59 18.88a1.71 1.71 0 0 0 0 1.33 1.51 1.51 0 0 0 0.41 0.49l-0.78 2a0.75 0.75 0 0 0 0.43 1 0.65 0.65 0 0 0 0.27 0.05 0.75 0.75 0 0 0 0.7 -0.48l0.78 -2a2 2 0 0 0 0.58 -0.14 1.77 1.77 0 0 0 0.92 -1l4 -10.08a0.53 0.53 0 0 0 0 -0.41 0.51 0.51 0 0 0 -0.36 -0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.88 6V3.51a1 1 0 0 0 -1 -1 0.5 0.5 0 0 1 -0.5 -0.5V1a1 1 0 0 0 -2 0v1a0.5 0.5 0 0 1 -0.5 0.5 1 1 0 0 0 -1 1V6a2.5 2.5 0 1 0 5 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.12 5.51h3.25a0.5 0.5 0 0 0 0.5 -0.5V1.5a1.5 1.5 0 0 0 -1.5 -1.5h-5a1.5 1.5 0 0 0 -1.5 1.5V14a0.58 0.58 0 0 0 0 0.19l2.76 6.91a3.29 3.29 0 0 1 0 2.23 0.5 0.5 0 0 0 0.06 0.46 0.51 0.51 0 0 0 0.41 0.21h3.2a1.5 1.5 0 0 0 1.5 -1.5v-4a0.5 0.5 0 0 0 -0.5 -0.5h-3.18a0.75 0.75 0 0 1 0 -1.5h3.25a0.5 0.5 0 0 0 0.5 -0.5v-3a0.5 0.5 0 0 0 -0.5 -0.5h-2.25a0.75 0.75 0 0 1 0 -1.5h2.25a0.5 0.5 0 0 0 0.5 -0.5v-3a0.5 0.5 0 0 0 -0.5 -0.5h-3.25a0.75 0.75 0 0 1 0 -1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArchitecture);
export default ForwardRef;